import React from 'react'
import { SvgIcon } from '../svg-icon'

/**
 * Define default props as fallback. See SvgIcon base class for propTypes.
 *
 * @static
 * @type {React.defaultProps}
 */
const defaultProps = {
    viewBoxSize: 48
}

/**
 * Stateless function representing a clock icon.
 *
 * @function
 * @param {Object} [props] The component properties
 * @returns {ReactElement} React component markup
 *
 * @see SvgIcon
 * @example
 * <ClockIcon width={12} />
 */
const ClockIcon = props => (
    <SvgIcon viewBox="0 0 48 48" {...props}>
        <path
            d="M24,46A22.15,22.15,0,0,1,1.9,24.05a22.14,22.14,0,0,1,22-22,
            22.14,22.14,0,0,1,22,21.86A22.15,22.15,0,0,1,24,46ZM41.9,24a18,
            18,0,1,0-18,18A18.05,18.05,0,0,0,41.9,24Zm-12,3.62L26,
            23.46V11.82a2.06,2.06,0,1,0-4.11,0V24.29c0,.1,0,.2,0,.31v0A1.89,
            1.89,0,0,0,22,25L22,25a1.87,1.87,0,0,0,.15.32l0,0a2.09,2.09,0,0,
            0,.23.29v0l4.51,4.76a2.06,2.06,0,1,0,3-2.83Z"
        />
    </SvgIcon>
)

ClockIcon.defaultProps = defaultProps

export { ClockIcon }
